/**
 * Overview — visão geral do canal Cloud API.
 * Hero card com phone, business_name, foto (se houver), qualidade, tier, ações.
 */

import React from 'react';
import { Spinner } from 'react-bootstrap';
import {
  IconBrandMeta,
  IconRefresh,
  IconUserCircle,
  IconShieldCheck,
} from '@tabler/icons-react';
import useCloudApiStatus from '../useStatus';

const StatBlock = ({ label, value, variant }) => (
  <div className="cloudapi-stat">
    <p className="cloudapi-stat__label">{label}</p>
    <p
      className="cloudapi-stat__value"
      style={
        variant === 'danger'
          ? { color: '#dc2626' }
          : variant === 'warning'
          ? { color: '#d97706' }
          : variant === 'success'
          ? { color: '#16a34a' }
          : undefined
      }
    >
      {value || '—'}
    </p>
  </div>
);

const Overview = ({ agentId, switchTab }) => {
  const status = useCloudApiStatus(agentId);

  if (status.isLoading) {
    return (
      <div style={{ padding: 32, textAlign: 'center' }}>
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  if (!status.isConnected) {
    return (
      <div style={{ padding: 32, textAlign: 'center', color: '#6b7280' }}>
        <IconBrandMeta size={48} style={{ marginBottom: 12, color: '#9ca3af' }} />
        <p>Canal não conectado.</p>
      </div>
    );
  }

  const data = status.raw || {};
  const profileUrl = data.business_profile?.profile_picture_url;

  return (
    <div>
      <div className="cloudapi-hero">
        <div className="cloudapi-hero__avatar">
          {profileUrl ? (
            <img src={profileUrl} alt="Foto de perfil" />
          ) : (
            <IconBrandMeta size={28} />
          )}
        </div>
        <div className="cloudapi-hero__info">
          <h3 className="cloudapi-hero__phone">
            {data.display_phone_number || '—'}
            {data.verified && (
              <IconShieldCheck
                size={18}
                style={{ marginLeft: 6, color: '#1877F2', verticalAlign: 'middle' }}
                title="Negócio verificado"
              />
            )}
          </h3>
          <p className="cloudapi-hero__business">
            {data.business_name || 'WhatsApp Business Account'}
          </p>
          <div className="cloudapi-hero__pills">
            {data.quality_rating && (
              <span className={`channel-card__status-pill channel-card__status-pill--${status.qualityVariant}`}>
                Qualidade: {data.quality_rating}
              </span>
            )}
            {status.tierLabel && (
              <span className="channel-card__status-pill channel-card__status-pill--info">
                Tier: {status.tierLabel}
              </span>
            )}
          </div>
        </div>
        <div className="cloudapi-hero__actions">
          <button
            type="button"
            className="cloudapi-hero__action-btn"
            onClick={() => status.refresh()}
            title="Atualizar"
          >
            <IconRefresh size={14} />
            Atualizar
          </button>
          <button
            type="button"
            className="cloudapi-hero__action-btn"
            onClick={() => switchTab('profile')}
          >
            <IconUserCircle size={14} />
            Editar perfil
          </button>
        </div>
      </div>

      <div className="cloudapi-stats">
        <StatBlock label="Status" value={status.statusLabel} variant={status.statusVariant} />
        <StatBlock label="Qualidade" value={data.quality_rating} variant={status.qualityVariant} />
        <StatBlock label="Tier" value={status.tierLabel || data.messaging_limit} />
        <StatBlock label="Verificado" value={data.verified ? 'Sim' : 'Não'} />
      </div>
    </div>
  );
};

export default Overview;
